import './BannerOverlay.scss'

const BannerOverlay = ({ backgroundColor }: { backgroundColor?: string }) => (
    <div
        className="fs-banner-overlay"
        style={{
            backgroundColor: backgroundColor ?? 'rgba(0, 0, 0, 0.4)'
        }}
    />
)

export default BannerOverlay
